import { BlackPopupRolagem } from "@/components/blog/BlackPopupRolagem";
import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/feo/SiteHeader";
import { BlackDestaqueSection } from "@/components/black2x1/BlackDestaqueSection";
import { SiteFooter } from "@/components/feo/SiteFooter";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade | Fisio em Ortopedia" },
      { name: "description", content: "Como o Portal Fisio em Ortopedia coleta, utiliza, armazena e protege as informações pessoais dos usuários, em conformidade com a LGPD." },
      { property: "og:title", content: "Política de Privacidade | Fisio em Ortopedia" },

      { property: "og:description", content: "Como tratamos seus dados pessoais em conformidade com a LGPD." },
      { property: "og:url", content: "https://fisioemortopedia.com.br/politica-de-privacidade" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/politica-de-privacidade" }],
  }),
  component: PoliticaPage,
});


function PoliticaPage() {
  return (
    <div className="min-h-screen bg-white text-[#13123a]">
      <SiteHeader />

      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6 max-w-3xl">
          <p className="text-[var(--brand-soft)] font-semibold uppercase tracking-widest text-xs mb-3">Legal</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4">
            Política de Privacidade
          </h1>
          <p className="text-[#13123a]/70 text-sm sm:text-base">
            Fisio em Ortopedia · Grupo Superador Saúde e Inovação LTDA.
          </p>

          <div className="mt-10 space-y-8 text-[#13123a]/85 text-base leading-relaxed">
            <p>
              Esta Política de Privacidade descreve como a Fisio em Ortopedia (<a href="https://www.fisioemortopedia.com.br/" className="text-[var(--brand-soft)] hover:underline" target="_blank" rel="noopener noreferrer">www.fisioemortopedia.com.br</a>), nome fantasia do Grupo Superador Saúde e Inovação LTDA (CNPJ nº 41.515.956/0001-03), coleta, utiliza, armazena e protege as informações pessoais de seus usuários, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e demais legislações aplicáveis.
            </p>

            <Block title="Coleta de informações">
              <p>Podemos coletar informações pessoais quando você:</p>
              <ul>
                <li>Preenche formulários em nosso site, landing pages ou plataformas de inscrição;</li>
                <li>Realiza uma compra de nossos cursos, eventos ou assinaturas;</li>
                <li>Se inscreve em nossa newsletter, comunidade ou lista de espera;</li>
                <li>Interage conosco por e-mail, telefone, WhatsApp ou redes sociais;</li>
                <li>Navega em nosso site (por meio de cookies e tecnologias similares).</li>
              </ul>
              <p>
                As informações coletadas podem incluir, mas não se limitam a: nome, e-mail, telefone, CPF, endereço, dados de pagamento, profissão, área de atuação, preferências de conteúdo e histórico de interação.
              </p>
            </Block>

            <Block title="Uso das informações">
              <p>Utilizamos os dados coletados para:</p>
              <ul>
                <li>Processar e gerenciar inscrições, compras e pagamentos;</li>
                <li>Enviar comunicações sobre cursos, eventos e conteúdos da Fisio em Ortopedia;</li>
                <li>Oferecer suporte e atendimento ao cliente;</li>
                <li>Melhorar a experiência do usuário em nosso site e plataformas;</li>
                <li>Personalizar ofertas e conteúdos de acordo com o seu perfil;</li>
                <li>Cumprir obrigações legais e regulatórias.</li>
              </ul>
            </Block>

            <Block title="Compartilhamento de informações">
              <p>
                Seus dados pessoais não são vendidos ou compartilhados com terceiros para fins comerciais não autorizados. Podemos compartilhar informações com:
              </p>
              <ul>
                <li>Autoridades públicas, quando exigido por lei ou determinação judicial;</li>
                <li>Prestadores de serviço que auxiliam na operação (plataformas de pagamento, hospedagem, e-mail marketing, etc).</li>
              </ul>
              <p>
                Nosso site possui um botão de login que direciona para uma área de membros hospedada em plataforma externa. Essa plataforma pode coletar e processar dados pessoais de acordo com suas próprias políticas de privacidade. Recomendamos que você leia atentamente os termos e políticas disponibilizados por essa plataforma antes de utilizar seus serviços.
              </p>
            </Block>

            <Block title="Armazenamento e segurança">
              <p>
                Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda, uso indevido ou divulgação. Seus dados são armazenados em servidores seguros, podendo estar localizados no Brasil ou no exterior, observadas as exigências legais aplicáveis.
              </p>
            </Block>

            <Block title="Cookies e tecnologias similares">
              <p>
                Utilizamos cookies e tecnologias similares para melhorar a navegação, analisar o uso do site e personalizar conteúdos e anúncios. Você pode gerenciar suas preferências de cookies diretamente nas configurações do seu navegador.
              </p>
            </Block>

            <Block title="Direitos do titular">
              <p>Você tem direito a:</p>
              <ul>
                <li>Confirmar a existência de tratamento de seus dados;</li>
                <li>Acessar, corrigir ou atualizar seus dados pessoais;</li>
                <li>Solicitar a exclusão de seus dados, quando aplicável;</li>
                <li>Revogar consentimentos concedidos;</li>
                <li>Solicitar a portabilidade de seus dados.</li>
              </ul>
              <p>
                Para exercer seus direitos, entre em contato pelo e-mail: <a href="mailto:contato@fisioemortopedia.com.br" className="text-[var(--brand-soft)] hover:underline">contato@fisioemortopedia.com.br</a>.
              </p>
            </Block>

            <Block title="Alterações nesta política">
              <p>
                Esta Política de Privacidade pode ser atualizada a qualquer momento para refletir mudanças em nossos processos ou exigências legais. A versão mais recente estará sempre disponível em nosso site.
              </p>
            </Block>

            <Block title="Contato">
              <p>Para dúvidas ou solicitações sobre esta Política, entre em contato:</p>
              <p>
                Grupo Superador Saúde e Inovação LTDA<br />
                CNPJ: 41.515.956/0001-03<br />
                Site: <a href="https://www.fisioemortopedia.com.br/" className="text-[var(--brand-soft)] hover:underline" target="_blank" rel="noopener noreferrer">www.fisioemortopedia.com.br</a><br />
                E-mail: <a href="mailto:contato@fisioemortopedia.com.br" className="text-[var(--brand-soft)] hover:underline">contato@fisioemortopedia.com.br</a>
              </p>
            </Block>
          </div>
        </div>
      </section>

      <BlackDestaqueSection origem="politica-de-privacidade" />

      <BlackPopupRolagem origem="politica-de-privacidade" />
      <SiteFooter />
    </div>
  );
}

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-bold text-[#13123a] mb-3">{title}</h2>
      <div className="space-y-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_ul]:my-3">
        {children}
      </div>
    </div>
  );
}
